import classNames from 'classnames';
import React from 'react';

import TextField from './Text';

import styles from '../../../styles/fields/email.module.scss';

interface EmailFieldProps {
    className?: string;
    inputRef?: React.Ref<HTMLInputElement>;
    [key: string]: any;
}

const EmailField: React.FC<EmailFieldProps> = ({ className, inputRef, ...props }) => (
    <TextField
        type="email"
        className={classNames([styles.input, className])}
        inputRef={inputRef}
        {...props}
    />
);

export default React.forwardRef<HTMLInputElement, Omit<EmailFieldProps, 'inputRef'>>(
    (props, ref) => <EmailField inputRef={ref} {...props} />,
);
